import { withDependencies } from '@wix/thunderbolt-ioc'
import type { BrowserWindow } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'
import type { IUrlHistoryManager } from 'feature-router'
import { UrlHistoryManagerSymbol } from 'feature-router'
import type { IScrollRestorationAPI } from './types'
import { isSSR } from '@wix/thunderbolt-commons'

const scrollRestorationFactory = (
	browserWindow: BrowserWindow,
	urlHistoryManager: IUrlHistoryManager
): IScrollRestorationAPI => {
	const getScrollYHistoryState = () => {
		const state = urlHistoryManager.getHistoryState()
		return state?.scrollY
	}

	return {
		getScrollYHistoryState,
		updateHistoryStateCurrentScrollY() {
			if (!isSSR(browserWindow)) {
				urlHistoryManager.updateHistoryState({ scrollY: browserWindow.scrollY })
			}
		},
		restoreScrollPosition() {
			if (!isSSR(browserWindow)) {
				const scrollY = getScrollYHistoryState()
				if (scrollY) {
					browserWindow.scrollTo(0, scrollY)
				}
			}
		},
		scrollToTop(behavior?: ScrollBehavior) {
			if (!isSSR(browserWindow)) {
				browserWindow.scrollTo({ left: 0, top: 0, behavior })
			}
		},
	}
}

export const ScrollRestorationAPI = withDependencies(
	[BrowserWindowSymbol, UrlHistoryManagerSymbol],
	scrollRestorationFactory
)
